import { useSelector } from "react-redux";

export function useCheckPageAccess(permission, url) {
  const { permissions, wlOtcEnabled } = useSelector((state) => state.auth);

  if (url === "/otc-settlement") {
    return wlOtcEnabled;
  } else if (url === "/request-settlement" && wlOtcEnabled) {
    return false;
  }
  const foundPermission = permissions.find(elem => elem.permission === permission);
  if (!foundPermission) {
    return false;
  }

  return foundPermission?.state;
}